import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

const { ui } = constants.colors;

export const modalStyles = {
  root: {
    zIndex: 10,
  },
  title: {
    color: ui.neutral[600],
    fontSize: "1.5rem",
  },
  modalContentWrapper: {
    maxWidth: "800px !important",
  },
  scrollableBody: {
    [breakpoint.upTo("xs")]: {
      minHeight: "65%",
      maxHeight: "65%",
      overflow: "auto",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "end",
  },
};

export const subtitleStyles = {
  margin: "0",
  color: ui.neutral[600],
  fontSize: "1.25rem",
  marginBottom: "24px",
};

export const buttonStyles = {
  height: "48px",
  "&:last-child": {
    marginLeft: "16px",
  },
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    margin: "0 0 1rem 0",
    width: "100%",
    "&:last-child": {
      margin: "0",
    },
  },
};

export const iconStyles = {
  height: "1.5rem",
  width: "1.5rem",
};
